module.exports = __webpack_public_path__ + "static/media/cedula1.7d7b330e.png";